import { render } from "./ShippingAll.vue?vue&type=template&id=f63f85fc"
import script from "./ShippingAll.vue?vue&type=script&lang=js"
export * from "./ShippingAll.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__